// extracted by mini-css-extract-plugin
export default {"container":"qa_container__nvIHY","qa_container_left":"qa_qa_container_left__7A7s4","qa_container_right":"qa_qa_container_right__vfFaW","link_btn":"qa_link_btn__djwk4"};